__webpack_require__.p = "/shopping-mall/";